//user action types

const actionTypes = {
	EMAIL_SIGN_IN_START: 'EMAIL_SIGN_IN_START',
	SIGN_IN_SUCCESS: 'SIGN_IN_SUCCESS',
	SIGN_IN_ERROR: 'SIGN_IN_ERROR',
	SIGN_OUT: 'SIGN_OUT',
	SIGN_UP_SUCCESS: 'SIGN_UP_SUCCESS',
	SIGN_UP_ERROR: 'SIGN_UP_ERROR',
	CHECK_USER_SESSION: 'CHECK_USER_SESSION',
	SIGN_OUT_USER_START: 'SIGN_OUT_USER_START',
	SIGN_OUT_USER_SUCCESS: 'SIGN_OUT_USER_SUCCESS',
	SIGN_UP_USER_START: 'SIGN_UP_USER_START',
	RESET_PASSWORD_START: 'RESET_PASSWORD_START',
	RESET_PASSWORD_SUCCESS: 'RESET_PASSWORD_SUCCESS',
	GOOGLE_SIGN_IN_START: 'GOOGLE_SIGN_IN_START',
	USER_ERROR: 'USER_ERROR',
	RESET_USER_STATE: 'RESET_USER_STATE',
	ADD_NEW_PRODUCT_START: 'ADD_NEW_PRODUCT_START',
	FETCH_PRODUCTS_START: 'FETCH_PRODUCTS_START',
	SET_PRODUCTS: 'SET_PRODUCTS',
	DELETE_PRODUCT_START: 'DELETE_PRODUCT_START',
	FETCH_PRODUCT_START: 'FETCH_PRODUCT_START',
	SET_PRODUCT: 'SET_PRODUCT',
	ADD_TO_CART: 'ADD_TO_CART',
	REMOVE_CART_ITEM: 'REMOVE_CART_ITEM',
	REDUCE_CART_ITEM: 'REDUCE_CART_ITEM',
	CLEAR_CART: 'CLEAR_CART',
	SAVE_ORDER_HISTORY_START: 'SAVE_ORDER_HISTORY_START',
	GET_USER_ORDER_HISTORY_START: 'GET_USER_ORDER_HISTORY_START',
	SET_USER_ORDER_HISOTRY: 'SET_USER_ORDER_HISOTRY',
	GET_ORDER_DETAILS_START: 'GET_ORDER_DETAILS_START',
	SET_ORDER_DETAILS: 'SET_ORDER_DETAILS'
};

export default actionTypes;
